var get = require('./get');

var UNDEF;
/**
 * Check if object has nested property.
 */

function has(obj, prop) {
  return get(obj, prop) !== UNDEF;
}

module.exports = has;